export default [
    {
        path: '/pages/admin/userIntegral',
        name: '/pages/admin/userIntegral',
        component: () => import('@/views/admin/userIntegral.vue')
    },
    {
        path: '/pages/admin/systemGoldSettingManage',
        name: '/pages/admin/systemGoldSettingManage',
        component: () => import('@/views/admin/systemGoldSettingManage.vue')
    },
    {
        path: '/pages/admin/storeOrderCartManage',
        name: '/pages/admin/storeOrderCartManage',
        component: () => import('@/views/admin/storeOrderCartManage.vue')
    },
    {
        path: '/pages/admin/storeIntegral',
        name: '/pages/admin/storeIntegral',
        component: () => import('@/views/admin/storeIntegral.vue')
    },
    {
        path: '/pages/admin/shopTypeManage',
        name: '/pages/admin/shopTypeManage',
        component: () => import('@/views/admin/shopTypeManage.vue')
    },
    {
        path: '/pages/admin/shopProductType',
        name: '/pages/admin/shopProductType',
        component: () => import('@/views/admin/shopProductType.vue')
    },
    {
        path: '/pages/admin/shopCommunity',
        name: '/pages/admin/shopCommunity',
        component: () => import('@/views/admin/shopCommunity.vue')
    },
    {
        path: '/pages/admin/merchantShop',
        name: '/pages/admin/merchantShop',
        component: () => import('@/views/admin/merchantShop.vue')
    },
    {
        path: '/pages/admin/merchantManage',
        name: '/pages/admin/merchantManage',
        component: () => import('@/views/admin/merchantManage.vue')
    },
    {
        path: '/pages/admin/mainCategoryProduct',
        name: '/pages/admin/mainCategoryProduct',
        component: () => import('@/views/admin/mainCategoryProduct.vue')
    },
    {
        path: '/pages/admin/mainCategoryManage',
        name: '/pages/admin/mainCategoryManage',
        component: () => import('@/views/admin/mainCategoryManage.vue')
    },
    {
        path: '/pages/admin/integralWithdrawal',
        name: '/pages/admin/integralWithdrawal',
        component: () => import('@/views/admin/integralWithdrawal.vue')
    },
    {
        path: '/pages/admin/integralSetting',
        name: '/pages/admin/integralSetting',
        component: () => import('@/views/admin/integralSetting.vue')
    },
    {
        path: '/pages/admin/integralDetail',
        name: '/pages/admin/integralDetail',
        component: () => import('@/views/admin/integralDetail.vue')
    },
    {
        path: '/pages/admin/housekeepingTypeManage',
        name: '/pages/admin/housekeepingTypeManage',
        component: () => import('@/views/admin/housekeepingTypeManage.vue')
    },
    {
        path: '/pages/admin/goldWithdrawal',
        name: '/pages/admin/goldWithdrawal',
        component: () => import('@/views/admin/goldWithdrawal.vue')
    },
    {
        path: '/pages/admin/goldDetail',
        name: '/pages/admin/goldDetail',
        component: () => import('@/views/admin/goldDetail.vue')
    },
    {
        path: '/pages/admin/goldBuyCartManage',
        name: '/pages/admin/goldBuyCartManage',
        component: () => import('@/views/admin/goldBuyCartManage.vue')
    },
    {
        path: '/pages/admin/gold',
        name: '/pages/admin/gold',
        component: () => import('@/views/admin/gold.vue')
    },
    {
        path: '/pages/admin/chainSupplierManage',
        name: '/pages/admin/chainSupplierManage',
        component: () => import('@/views/admin/chainSupplierManage.vue')
    },
    {
        path: '/pages/admin/ChainProduct',
        name: '/pages/admin/ChainProduct',
        component: () => import('@/views/admin/ChainProduct.vue')
    },
    {
        path: '/pages/admin/chainInoutOrder',
        name: '/pages/admin/chainInoutOrder',
        component: () => import('@/views/admin/chainInoutOrder.vue')
    },
    {
        path: '/pages/admin/auditShopCommunity',
        name: '/pages/admin/auditShopCommunity',
        component: () => import('@/views/admin/auditShopCommunity.vue')
    },
    {
        path: '/pages/admin/auditOpenShop',
        name: '/pages/admin/auditOpenShop',
        component: () => import('@/views/admin/auditOpenShop.vue')
    },
    {
        path: '/pages/admin/ApplyGoldWithdrawal',
        name: '/pages/admin/ApplyGoldWithdrawal',
        component: () => import('@/views/admin/ApplyGoldWithdrawal.vue')
    },
    {
        path: '/pages/admin/adminServ',
        name: '/pages/admin/adminServ',
        component: () => import('@/views/admin/adminServ.vue')
    },
    {
        path: '/pages/admin/AdminRefundCart',
        name: '/pages/admin/AdminRefundCart',
        component: () => import('@/views/admin/AdminRefundCart.vue')
    },
    {
        path: '/pages/admin/AccountWithdrawalApplyListManage',
        name: '/pages/admin/AccountWithdrawalApplyListManage',
        component: () => import('@/views/admin/AccountWithdrawalApplyListManage.vue')
    },
    {
        path: '/pages/admin/AccountWithdrawalApplyFkManage',
        name: '/pages/admin/AccountWithdrawalApplyFkManage',
        component: () => import('@/views/admin/AccountWithdrawalApplyFkManage.vue')
    },
    {
        path: '/pages/admin/AccountWithdrawalApplyShManage',
        name: '/pages/admin/AccountWithdrawalApplyShManage',
        component: () => import('@/views/admin/AccountWithdrawalApplyShManage.vue')
    },
    {
        path: '/pages/admin/AccountBondObjDetail',
        name: '/pages/admin/AccountBondObjDetail',
        component: () => import('@/views/admin/AccountBondObjDetail.vue')
    },
    {
        path: '/pages/admin/AccountBond',
        name: '/pages/admin/AccountBond',
        component: () => import('@/views/admin/AccountBond.vue')
    },
    {
        path: '/pages/admin/index',
        name: '/pages/admin/index',
        component: () => import('@/views/admin/index.vue')
    },
    {
        path: '/pages/admin/addChainProduct',
        name: '/pages/admin/addChainProduct',
        component: () => import('@/views/admin/addChainProduct.vue')
    },
    {
        path: '/pages/admin/editChainProduct',
        name: '/pages/admin/editChainProduct',
        component: () => import('@/views/admin/editChainProduct.vue')
    },
    {
        path: '/pages/admin/pointsExchangeGoodsManage',
        name: '/pages/admin/pointsExchangeGoodsManage',
        component: () => import('@/views/admin/pointsExchangeGoodsManage.vue')
    },
    {
        path: '/pages/admin/pointsExchangeOrderManage',
        name: '/pages/admin/pointsExchangeOrderManage',
        component: () => import('@/views/admin/pointsExchangeOrderManage.vue')
    }
]